var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 12,
    fill: "#9EA9B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2507 15.8592C27.2507 18.5428 25.1237 20.7183 22.5 20.7183C19.8762 20.7183 17.7493 18.5428 17.7493 15.8592C17.7493 13.1755 19.8762 11 22.5 11C25.1237 11 27.2507 13.1755 27.2507 15.8592Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31.8856C13.0891 26.5971 17.3083 24.2817 22.5 24.2817C27.6919 24.2817 31.9111 26.5973 32 31.886C29.108 33.2433 25.8906 34 22.5004 34C19.1099 34 15.8922 33.2432 13 31.8856Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.b65906273d97b442c605ca1d73af7e4c.svg";
export { ForwardRef as ReactComponent };